import { css } from 'linaria';

export const menuWrap = css`
  display: flex;
  flex-direction: column;
  width: 280px;
`;
